import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { Instagram } from "lucide-react";
import logoImg from "@assets/304812284_1289087155231419_6768177109020011162_n_1766756930635.jpg";

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[hsl(217,54%,18%)] text-slate-300 py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <Link href="/" className="flex items-center gap-2 mb-6 text-white">
              <img src={logoImg} alt="King Wash Logo" className="h-10 w-10 rounded-lg object-cover" />
              <span className="font-display font-bold text-xl tracking-tight">King Wash</span>
            </Link>
            <p className="text-sm leading-relaxed opacity-80">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.quickLinks")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link href="/" className="hover:text-[hsl(32,83%,54%)] transition-colors">{t("nav.home")}</Link></li>
              <li><Link href="/services" className="hover:text-[hsl(32,83%,54%)] transition-colors">{t("nav.services")}</Link></li>
              <li><Link href="/booking" className="hover:text-[hsl(32,83%,54%)] transition-colors">{t("nav.booking")}</Link></li>
              <li><Link href="/about" className="hover:text-[hsl(32,83%,54%)] transition-colors">{t("nav.about")}</Link></li>
              <li><Link href="/terms" className="hover:text-[hsl(32,83%,54%)] transition-colors">{t("footer.terms")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.contact")}</h4>
            <ul className="space-y-2 text-sm">
              <li>60022490</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.connect")}</h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/kingwashkw/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[hsl(217,54%,24%)] flex items-center justify-center hover:bg-[hsl(32,83%,54%)] hover:text-white transition-colors" data-testid="link-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[hsl(217,54%,28%)] pt-8 text-center text-xs opacity-50">
          © {new Date().getFullYear()} King Wash. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
